import Plot from "react-plotly.js";
import { Button, Icon } from "semantic-ui-react";

const COR_BARRAS = "#4183c4";

function GraficoProcessosPorObjeto({ dados, onExpandir }) {
  // Ordena por valor e pega top 10, agrupa resto em "Outros"
  const ordenados = [...(dados || [])].sort((a, b) => b.valor - a.valor);
  const top10 = ordenados.slice(0, 10);
  const outrosValor = ordenados.slice(10).reduce((acc, item) => acc + item.valor, 0);
  
  if (outrosValor > 0) {
    top10.push({ label: 'Outros', valor: outrosValor });
  }

  // Inverte para o gráfico horizontal (maior em cima)
  const labels = top10.map((item) => item.label?.trim()).reverse();
  const values = top10.map((item) => item.valor).reverse();

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
        <div />
        {onExpandir && (
          <Button 
            icon 
            size="mini" 
            basic 
            onClick={() => onExpandir(ordenados, 'Por Objeto')}
            title="Ver todos os objetos"
          >
            <Icon name="expand" />
          </Button>
        )}
      </div>
      <Plot
        data={[
          {
            type: "bar",
            y: labels,
            x: values,
            orientation: "h",
            marker: { color: COR_BARRAS },
            text: values.map(String),
            textposition: "outside",
            hoverinfo: "y+x",
          },
        ]}
        config={{
          responsive: true,
          staticPlot: true,
          displayModeBar: false,
        }}
        useResizeHandler={true}
        style={{ width: "100%", height: "300px" }}
        layout={{
          title: {
            text: "<b>POR OBJETO (TOP 10)</b>",
            font: {
              family: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
              size: 14,
              color: "#37536d",
            },
          },
          xaxis: {
            showgrid: true,
            gridcolor: "#e0e0e0",
          },
          yaxis: {
            tickfont: { size: 9 },
            automargin: true,
          },
          margin: { t: 40, b: 30, l: 140, r: 50 },
        }}
      />
    </div>
  );
}

export default GraficoProcessosPorObjeto;
